import {
  Avatar,
  Chip,
  Divider,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  Trash
} from '@hermes/web-components'
import { FC } from 'react'

type BookListItemProps = {
  primaryText: string
  secondaryText: string
  hasChip?: boolean
  primaryChipLabel?: string
  secondaryChipLabel?: string
  chipOnHover?: boolean
  onClickListItem: () => void
  onClickSecondaryAction?: () => void
  secondaryActionDisabled: boolean
  bookImageUrl: string
}

export const BookListItem: FC<BookListItemProps> = ({
  primaryText,
  secondaryText,
  hasChip = true,
  primaryChipLabel,
  secondaryChipLabel,
  bookImageUrl,
  chipOnHover,
  onClickListItem,
  onClickSecondaryAction,
  secondaryActionDisabled
}) => (
  <>
    <ListItem
      sx={{
        '&:hover .MuiListItemSecondaryAction-root .MuiButtonBase-root': {
          visibility: chipOnHover ? 'visible' : 'hidden'
        },
        '.MuiListItemSecondaryAction-root .MuiButtonBase-root': {
          visibility: 'hidden'
        }
      }}
      disablePadding
      secondaryAction={
        hasChip ? (
          <Stack direction={'row'} spacing={1}>
            <Chip label={primaryChipLabel} variant="outlined" color="primary" />
            {onClickSecondaryAction && !secondaryActionDisabled ? (
              <IconButton onClick={onClickSecondaryAction} edge="end" aria-label="delete">
                <Trash />
              </IconButton>
            ) : null}
          </Stack>
        ) : null
      }
    >
      <ListItemButton
        sx={{
          '&:hover, &.active, &:focus': {
            backgroundColor: 'transparent'
          }
        }}
        onClick={onClickListItem}
      >
        <ListItemAvatar>
          <Avatar src={bookImageUrl} variant="rounded" sx={{ width: '44px', height: '62px' }} />
        </ListItemAvatar>
        <ListItemText
          primary={primaryText}
          primaryTypographyProps={{ variant: 'body1' }}
          secondary={secondaryText}
          secondaryTypographyProps={{ variant: 'body2' }}
          sx={{
            paddingLeft: '12px'
          }}
        />
        {hasChip && (
          <Stack direction={'row'} spacing={1} sx={{ visibility: 'hidden' }}>
            <Chip label={secondaryChipLabel} variant="outlined" color="primary" />
            <IconButton edge="end" aria-label="delete">
              <Trash />
            </IconButton>
          </Stack>
        )}
      </ListItemButton>
    </ListItem>
    <Divider sx={{ height: '1px' }} />
  </>
)
